<form *ngIf="form" [formGroup]="form">
  <div [ngSwitch]="control.controlType" *ngIf="control.viewState!=='Invisible' && control.viewState!=='NotSorrento'">
    <mat-form-field class="mb-3" *ngSwitchCase="'autocomplete'"  (keydown.Tab)="onPressTab($event)">
      <input type="text"
             [placeholder]="fieldLabelToDisplay" matInput
             [formControlName]="control.key" [matAutocomplete]="auto" [errorStateMatcher]="matcher" (focus)="selectControl()"
             [id]="control.key" [(value)]="control.value">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of control.valueOptions" [value]="option">
          {{option}}
        </mat-option>
      </mat-autocomplete>

      <mat-error class="errorMessage" *ngIf="!isRequired; else checkTextValueAutocomplete">
        {{fieldLabelToDisplay}} {{'Error.Required' | translate}}</mat-error>
      <ng-template #checkTextValueAutocomplete>
        <mat-error class="errorMessage" *ngIf="!isRegexOk || !isMOD97Ok">{{fieldLabelToDisplay}}
          {{'Error.NotValid' | translate}}</mat-error>
      </ng-template>
    </mat-form-field>


    <mat-form-field class="mb-3" *ngSwitchCase="'textbox'">
      <input matInput [placeholder]="fieldLabelToDisplay" [formControlName]="control.key"
             [id]="control.key" [errorStateMatcher]="matcher" (focus)="selectControl()">

      <mat-error class="errorMessage" *ngIf="!isRequired; else checkTextValueTextbox">
        {{fieldLabelToDisplay}} {{'Error.Required' | translate}}</mat-error>
      <ng-template #checkTextValueTextbox>
        <mat-error class="errorMessage" *ngIf="!isRegexOk || !isMOD97Ok">{{fieldLabelToDisplay}}
          {{'Error.NotValid' | translate}}</mat-error>
      </ng-template>
    </mat-form-field>

    <mat-form-field class="mb-3" *ngSwitchCase="'dropdown'">
      <mat-label>{{fieldLabelToDisplay}}</mat-label>
      <mat-select [formControlName]="control.key" [errorStateMatcher]="matcher" (focus)="selectControl()"
        [id]="control.key">
        <mat-option *ngFor="let opt of control.options" [value]="opt.key" [id]=opt.value>
          {{opt.value}}
        </mat-option>
      </mat-select>
      <mat-error class="errorMessage" *ngIf="!isRequired">{{fieldLabelToDisplay}}
        {{'Error.Required' | translate}}</mat-error>
    </mat-form-field>

    <mat-form-field class="mb-3" *ngSwitchCase="'datepicker'" class="example-full-width">
      <input matInput [matDatepicker]="picker" [placeholder]="fieldLabelToDisplay"
        [formControlName]="control.key" [id]="control.key" [errorStateMatcher]="matcher" (focus)="selectControl()">
      <mat-datepicker-toggle matSuffix [for]="picker">
        <i matDatepickerToggleIcon class="fi fi-rr-calendar-day"></i>
      </mat-datepicker-toggle>
      <mat-datepicker #picker (opened)="selectControl()"></mat-datepicker>
      <mat-error class="errorMessage" *ngIf="!isRequired; else checkDateValue">
        {{fieldLabelToDisplay}} {{'Error.Required' | translate}}</mat-error>
      <ng-template #checkDateValue>
        <mat-error class="errorMessage" *ngIf="!isDateRangeOk">
          <div *ngIf="dateRangeMin">{{'Error.DateRangeMin' | translate}} {{dateRangeMin}} {{timeSpanMessage}}</div>
          <div *ngIf="dateRangeMax">{{'Error.DateRangeMax' | translate}} {{dateRangeMax}} {{timeSpanMessage}}</div>
        </mat-error>
      </ng-template>
    </mat-form-field>

    <div *ngSwitchCase="'table'" class="table">
      <div class="table_header">
        <b>{{fieldLabelToDisplay}}</b>
      </div>
      <app-table-field [rows]="control.children" [tableColumns]="control.columns" [tableKey]="control.key" [form]="form" [control]="control"
        (addRow)="rowAdd()" (removeRow)="rowRemove($event)" (rowOrderChanged)="changeRowOrder($event)">
      </app-table-field>
    </div>
  </div>
</form>
